// extracted by mini-css-extract-plugin
module.exports = {"header":"AppHeader_header__3byp8","headerLogo":"AppHeader_headerLogo__1Xjgo","headerNav":"AppHeader_headerNav__3mmGc","headerVersion":"AppHeader_headerVersion__zCDAF"};